import { Tooltip } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";

import { ObjectType } from "@/types";
import { getObjectMetadata } from "@/utils/libraryObjectUtils";

interface TileObjectTypeIndicatorProps {
  objectType: ObjectType;
  isSelected?: boolean;
  isFocused?: boolean;
}

const getBackgroundColor = (
  isSelected: boolean,
  isFocused: boolean,
  theme: Theme,
) => {
  if (isSelected) {
    return theme.palette.primary.light;
  }

  if (isFocused) {
    return theme.palette.secondary[4];
  }

  return theme.palette.secondary["4/50"];
};

const StyledContainer = styled("div")<{
  isSelected?: boolean;
  isFocused?: boolean;
}>(({ theme, isSelected, isFocused }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "2em",
  height: "2em",
  fontSize: "0.8em",
  minWidth: "0px",
  minHeight: "0px",
  maxWidth: "none",
  maxHeight: "none",
  borderBottomRightRadius: 4,
  "& svg": {
    display: "block",
    fontSize: "1.2em",
  },
  backgroundColor: getBackgroundColor(
    isSelected ?? false,
    isFocused ?? false,
    theme,
  ),
}));

export const TileObjectTypeIndicator = (
  props: TileObjectTypeIndicatorProps,
) => {
  const { objectType, isSelected, isFocused, ...rest } = props;

  const { icon, label } = getObjectMetadata(objectType);

  return (
    <StyledContainer isSelected={isSelected} isFocused={isFocused} {...rest}>
      <Tooltip title={label.charAt(0).toUpperCase() + label.slice(1)}>
        <span>{icon}</span>
      </Tooltip>
    </StyledContainer>
  );
};
